import React, { useContext } from "react";
import clsx from "clsx";
import { Col, Form, Row } from "react-bootstrap";
import { connect, RootStateOrAny } from "react-redux";
import { Field, InjectedFormProps, reduxForm } from "redux-form";

import { RadioButton, Skeleton } from "components";
import { HighRiskContext } from "components/contexts";
import { useLoader } from "hooks";

import styles from "./residuals.module.scss";

type HighRiskFormStateProps = {
	isHighRisk: string;
};

type HighRiskFormProps = {
	isLoading: boolean;
	isEditable: boolean;
	highRiskChangeHandler: Function;
} & HighRiskFormStateProps;

type HighRiskFieldProps = {
	isEditable: boolean;
	isHighRisk: boolean;
	onChange: (...values: any) => void;
};

const HighRiskField = ({
	isEditable,
	isHighRisk,
	onChange,
}: HighRiskFieldProps) => {
	if (isEditable) {
		return (
			<Row>
				<Col>
					<Field
						component={RadioButton}
						value={"true"}
						tabIndex={1}
						name={"isHighRisk"}
						label="Yes"
						type="radio"
						id={"isHighRiskTrue"}
						onChange={onChange}
					/>
				</Col>
				<Col>
					<Field
						component={RadioButton}
						value={"false"}
						tabIndex={1}
						name={"isHighRisk"}
						label="No"
						type="radio"
						id={"isHighRiskFalse"}
						onChange={onChange}
					/>
				</Col>
			</Row>
		);
	} else if (isHighRisk) {
		return <div>Yes</div>;
	} else {
		return <div>No</div>;
	}
};

const HighRiskForm = ({
	isLoading,
	isEditable,
	isHighRisk,
	highRiskChangeHandler,
}: HighRiskFormProps & InjectedFormProps<{}, HighRiskFormProps>) => {
	const Loader = useLoader(isLoading);
	const { highRiskCallback } = useContext(HighRiskContext);

	const handleChange = (e, value) => {
		highRiskChangeHandler(value === "true");
		highRiskCallback.current(value === "true");
	};

	return (
		<Form>
			<Row>
				<Col
					sm={7}
					className={clsx(
						styles.label,
						!isEditable && styles.disabled,
					)}
				>
					Is it a High Risk Application?
				</Col>
			</Row>
			<Row>
				<Col sm={7} className={styles.buttonContainer}>
					<Loader
						skeleton={<Skeleton height={30} />}
						component={
							<HighRiskField
								isEditable={isEditable}
								isHighRisk={isHighRisk === "true"}
								onChange={handleChange}
							/>
						}
					/>
				</Col>
			</Row>
		</Form>
	);
};

export default connect((state: RootStateOrAny) => ({
	initialValues: state.merchantInfo.merchantInfo,
	isHighRisk: state.merchantInfo.merchantInfo.isHighRisk,
}))(
	reduxForm<{}, HighRiskFormProps>({
		form: "merchantForm",
		destroyOnUnmount: false,
		enableReinitialize: true,
	})(HighRiskForm),
);
